import { Component, Input, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import {
  FileRestrictions,
  SelectEvent,
  RemoveEvent,
  ChunkSettings,
  UploadModule
} from "@progress/kendo-angular-upload";
import { fromEvent, map, Observable } from "rxjs";
import { BaseControl } from "../../ui/controls/base-control.model";
import { UploadControl } from "../../ui/controls/upload-control.model";
import { HttpClient } from '@angular/common/http';
import { EditEvent, GridDataResult, GridModule } from "@progress/kendo-angular-grid";
import { State, process } from '@progress/kendo-data-query';
import { ItemSearchResult } from "../../interfaces/gridrows/item-search-result.interface";
import { ItemService } from "../../../modules/items/services/item-service";
import { ActivatedRoute } from "@angular/router";
import { INotificationService } from "../../services/inotification.service";
import { AuthenticationService } from "../../../core/services/authentication.serivce";
import { ImageEntity } from "../../interfaces/entities/image.interface";
import { ScrollViewModule } from "@progress/kendo-angular-scrollview";
import { CommonModule } from "@angular/common";
import { Permission } from "../../../core/literals/permission.literal";

@Component({
    selector: 'app-upload-image',
    imports: [UploadModule, ScrollViewModule, GridModule, CommonModule],
    templateUrl: './upload-image.component.html',
    styleUrls: ['./upload-image.component.css']
})


export class UploadImageComponent implements OnInit {
  id: string;
  isReadOnly: boolean;
  itemImageResults: ImageEntity[] = [];
  public itemImageGridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };

  public itemImageGridData: GridDataResult = process(this.itemImageResults, this.itemImageGridState);

  imageData = [];
  public items: ImageEntity[] = this.imageData;
  public width = "110%";
  public height = "400px";

  isVisible: boolean = false;
  isEmpty: boolean = false;

  @ViewChild("itemImageSection", { read: ViewContainerRef, static: false }) public itemImageSection: ViewContainerRef;

  constructor(private http: HttpClient,
              private itemService: ItemService,
              private activatedRouter: ActivatedRoute,
              private notificationService: INotificationService,
              private auth: AuthenticationService)
  {
    this.activatedRouter.params.subscribe(params => this.id = params['id']);
  }

  @Input() control: BaseControl;
  uploadControl: UploadControl;

  ngOnInit(): void {

    this.isReadOnly = this.auth.isAdmin() ? false : true;

    this.uploadControl = this.control as UploadControl;

    this.itemService.getItemImages(this.id).subscribe((data => {
      this.itemImageGridData = process(data, this.itemImageGridState);
      this.itemImageResults = data;
      this.items = data;

      if (data.length == 0) { this.isEmpty = true };
    }));

    //If this is an admin or client admin, they should be allowed to add pictures - maybe make this a seperate permission??
    if (this.auth.isAdmin() || this.auth.canPerformAction(Permission.AddImages)) {
      this.isVisible = true;
    }
  }


  public events: string[] = [];
  public imagePreviews: { [key: string]: unknown }[] = [];
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png"],
    maxFileSize: 200000
  };
  public chunkSettings: ChunkSettings = {
    size: 102400,
  };
  public uploadSaveUrl = "saveUrl"; // should represent an actual API endpoint
  public uploadRemoveUrl = "removeUrl"; // should represent an actual API endpoint

  public remove(e: RemoveEvent): void {

    const index = this.imagePreviews.findIndex(
      (item) => item["uid"] === e.files[0].uid
    );

    if (index >= 0) {
      this.imagePreviews.splice(index, 1);

      this.uploadControl.data.splice(index, 1);
    }
  }

  public select(e: SelectEvent): void {
    const that = this;
    const fileNames: string[] = [];

    e.files.forEach((file) => {
      fileNames.push(file.name);

      if (!file.validationErrors) {
        const reader = new FileReader();

        reader.onload = function (ev) {
          const image = {
            src: ev.target?.result,
            uid: file.uid,
          };

          that.imagePreviews.unshift(image);
        };


        var blob = file.rawFile as Blob;

        this.toBase64(blob).subscribe(t => {


          var imageRecord = [];
          imageRecord.push(t);
          imageRecord.push(file.name);

          this.uploadControl.data.push(imageRecord);
        });

        reader.readAsDataURL(blob);
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: "There is a file restriction! Please try again." });
      }
    });
  }

  public toBase64(blob: Blob): Observable<string> {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return fromEvent(reader, 'load')
      .pipe(map(() => (reader.result as string)))
  }

  public removeImageHandler(args: EditEvent): void {

    this.itemService.removeItemImage(args.dataItem.id).subscribe((data => {
      if (data.wasSuccessful) {

        var pagedIndex = args.rowIndex > 100 ? (args.rowIndex % 100) : args.rowIndex;

        this.itemImageGridData.data.splice(pagedIndex, 1);
        this.itemImageResults.splice(args.rowIndex, 1);
        this.itemImageGridData = process(this.itemImageResults, this.itemImageGridState);

      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message, containerRef: this.itemImageSection });
      }
    }));
  }

  public photoURL(dataItem: { image: string; }): string {
    return "url(" + dataItem.image + ")";
  }
}
